import {createApp} from "vue";
import {createPinia} from "pinia";
import Index from "./components/pages/Index.vue";
import Company from "./components/pages/Company.vue";
import Simulation from "./components/pages/Simulation.vue";
import Mypage from "./components/pages/Mypage.vue";
import Member from "./components/pages/Member.vue";
export class MountManager {
    public static init(){
        //ComponentとマウントするIDの配列
        const components = [
            [Index,'indexVue'],
            [Company,'companyVue'],
            [Simulation,'simulationVue'],
            [Mypage,'mypageVue'],
            [Member,'memberVue'],
        ];
        globalThis.apps = [];
        components.forEach(this.mount);
    }
    
    private static mount(component){
        let el = document.getElementById(component[1]);
        if(el){
            const app = createApp(component[0]);
            app.use(createPinia());
            app.mount(el);
            globalThis.apps.push(app);
        }
    }
    
    
}